export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/google_analytics.bce6573.svg";